import { colors } from '@lmc/common/constants'
import { Chevron } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { ProfilePicture } from '../../../../components/generic'

export default class HandoverTitleBar extends Component {
  state = {
    isClicked: false
  }

  handleClick = () => {
    this.setState((prevState) => ({
      isClicked: !prevState.isClicked
    }))
    this.props.onClick()
  }

  formatTimePeriod = () => {
    const splitAfternoon = 12 // 24hr time to split the afternoon
    const splitEvening = 17 // 24hr time to split the evening
    const hour = parseFloat(dayjs(this.props.createdOn).format('HH'))

    if (hour >= splitAfternoon && hour <= splitEvening) {
      // Between 12 PM and 5PM
      return 'Afternoon'
    }
    if (hour >= splitEvening) {
      // Between 5PM and Midnight
      return 'Evening'
    }
    // Between dawn and noon
    return 'Morning'
  }

  renderCarers = () => {
    const { createdBy, witnessedBy } = this.props
    if (!witnessedBy || !createdBy) return null

    return (
      <div style={styles.carersContainer}>
        <div style={styles.carer}>
          <span style={styles.name}>
            By {createdBy.name.first} {createdBy.name.last}
          </span>
          <ProfilePicture
            url={createdBy.picture}
            style={styles.carerImage}
            type="handover__small"
          />
        </div>
        <div style={styles.carer}>
          <span style={styles.name}>
            to {witnessedBy.name.first} {witnessedBy.name.last}
          </span>
          <ProfilePicture
            url={witnessedBy.picture}
            style={styles.carerImage}
            type="handover__small"
          />
        </div>
      </div>
    )
  }

  render() {
    const isDesktopStyles = isBrowser || isTablet
    return (
      <div onClick={this.handleClick} style={styles.container}>
        <div style={styles.handoverTime}>
          {`${this.formatTimePeriod()} at ${dayjs(this.props.createdOn).format(
            'HH:mm'
          )}`}
        </div>
        <div style={styles.rightContainer}>
          {isDesktopStyles && this.renderCarers()}
          <Chevron direction={this.state.isClicked ? 'up' : 'down'} />
        </div>
      </div>
    )
  }
}

const styles = {
  carer: {
    display: 'flex',
    flexDirection: 'row'
  },
  carerImage: {
    marginRight: 10
  },
  carersContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  container: {
    borderBottom: `1px ${colors.grey} solid`,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    height: 50,
    justifyContent: 'space-between',
    marginTop: 10,
    width: '100%'
  },
  glyph: {
    paddingBottom: 10
  },
  handoverTime: {
    fontSize: 16,
    height: '100%',
    paddingTop: 8,
    textOverflow: 'ellipsis',
    hyphens: 'auto'
  },
  name: {
    display: 'block',
    fontSize: 14,
    opacity: 0.8,
    padding: '8px 10px 0px 0px'
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'row'
  }
}

HandoverTitleBar.propTypes = {
  createdOn: PropTypes.string.isRequired,
  createdBy: PropTypes.object,
  witnessedBy: PropTypes.object,
  onClick: PropTypes.func.isRequired
}
